import { baseApi as api } from "../baseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getV2ProviderSchedulingProspects: build.query<
      GetV2ProviderSchedulingProspectsApiResponse,
      GetV2ProviderSchedulingProspectsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/scheduling/prospects`,
        params: {
          limit: queryArg.limit,
          offset: queryArg.offset,
        },
      }),
    }),
    deleteV2ProviderSchedulingProspectsByBookingProspectId: build.mutation<
      DeleteV2ProviderSchedulingProspectsByBookingProspectIdApiResponse,
      DeleteV2ProviderSchedulingProspectsByBookingProspectIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/scheduling/prospects/${queryArg.bookingProspectId}`,
        method: "DELETE",
      }),
    }),
    getV2ProviderSchedulingProspectsByBookingProspectId: build.query<
      GetV2ProviderSchedulingProspectsByBookingProspectIdApiResponse,
      GetV2ProviderSchedulingProspectsByBookingProspectIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/scheduling/prospects/${queryArg.bookingProspectId}`,
      }),
    }),
    getV2ProviderSchedulingProspectsByBookingProspectIdMatches: build.query<
      GetV2ProviderSchedulingProspectsByBookingProspectIdMatchesApiResponse,
      GetV2ProviderSchedulingProspectsByBookingProspectIdMatchesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/scheduling/prospects/${queryArg.bookingProspectId}/matches`,
      }),
    }),
    postV2ProviderSchedulingProspectsByBookingProspectIdPromote: build.mutation<
      PostV2ProviderSchedulingProspectsByBookingProspectIdPromoteApiResponse,
      PostV2ProviderSchedulingProspectsByBookingProspectIdPromoteApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/scheduling/prospects/${queryArg.bookingProspectId}/promote`,
        method: "POST",
        body: queryArg.promoteProspectRequest,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type GetV2ProviderSchedulingProspectsApiResponse =
  /** status 200 OK */ BookingProspectListResponse;
export type GetV2ProviderSchedulingProspectsApiArg = {
  /** Page size */
  limit?: number;
  /** Page offset */
  offset?: number;
};
export type DeleteV2ProviderSchedulingProspectsByBookingProspectIdApiResponse =
  /** status 200 OK */ BookingProspectResponse;
export type DeleteV2ProviderSchedulingProspectsByBookingProspectIdApiArg = {
  bookingProspectId: string;
};
export type GetV2ProviderSchedulingProspectsByBookingProspectIdApiResponse =
  /** status 200 OK */ BookingProspectResponse;
export type GetV2ProviderSchedulingProspectsByBookingProspectIdApiArg = {
  bookingProspectId: string;
};
export type GetV2ProviderSchedulingProspectsByBookingProspectIdMatchesApiResponse =
  /** status 200 OK */ ProspectMatchesResponse;
export type GetV2ProviderSchedulingProspectsByBookingProspectIdMatchesApiArg = {
  bookingProspectId: string;
};
export type PostV2ProviderSchedulingProspectsByBookingProspectIdPromoteApiResponse =
  /** status 200 OK */ PromoteProspectResponse;
export type PostV2ProviderSchedulingProspectsByBookingProspectIdPromoteApiArg =
  {
    bookingProspectId: string;
    promoteProspectRequest: PromoteProspectRequest;
  };
export type BookingProspectSchema = {
  /** The pending (suggested) appointment this booking created */
  appointment_id?: string | null;
  /** Start time of the linked appointment */
  appointment_start_time?: string | null;
  /** Status of the linked appointment (suggested until confirmed) */
  appointment_status?: string | null;
  booking_prospect_id: string;
  created_at?: string | null;
  dob?: string | null;
  email?: string | null;
  first_name?: string | null;
  last_name?: string | null;
  phone?: string | null;
  promoted_patient_id?: string | null;
  /** Calendar owner the booking targets */
  provider_id: string;
  /** Visit reason the booker entered */
  reason?: string | null;
  status: string;
};
export type BookingProspectListResponse = {
  items: BookingProspectSchema[];
  /** Count of items in this page */
  total: number;
};
export type ValidationErrorElement = {
  ctx?: object;
  loc: string[];
  msg: string;
  type: string;
};
export type ValidationError = ValidationErrorElement[];
export type BookingProspectSchema2 = {
  /** The pending (suggested) appointment this booking created */
  appointment_id?: string | null;
  /** Start time of the linked appointment */
  appointment_start_time?: string | null;
  /** Status of the linked appointment (suggested until confirmed) */
  appointment_status?: string | null;
  booking_prospect_id: string;
  created_at?: string | null;
  dob?: string | null;
  email?: string | null;
  first_name?: string | null;
  last_name?: string | null;
  phone?: string | null;
  promoted_patient_id?: string | null;
  /** Calendar owner the booking targets */
  provider_id: string;
  /** Visit reason the booker entered */
  reason?: string | null;
  status: string;
};
export type BookingProspectResponse = {
  prospect: BookingProspectSchema2;
};
export type ClientErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the client error */
  status?: number;
};
export type ProspectMatchCandidateSchema = {
  /** Match confidence, 0-100 */
  confidence: number;
  dob?: string | null;
  name?: string | null;
  patient_id: string;
};
export type ProspectMatchesResponse = {
  items: ProspectMatchCandidateSchema[];
  total: number;
};
export type BookingProspectSchema3 = {
  /** The pending (suggested) appointment this booking created */
  appointment_id?: string | null;
  /** Start time of the linked appointment */
  appointment_start_time?: string | null;
  /** Status of the linked appointment (suggested until confirmed) */
  appointment_status?: string | null;
  booking_prospect_id: string;
  created_at?: string | null;
  dob?: string | null;
  email?: string | null;
  first_name?: string | null;
  last_name?: string | null;
  phone?: string | null;
  promoted_patient_id?: string | null;
  /** Calendar owner the booking targets */
  provider_id: string;
  /** Visit reason the booker entered */
  reason?: string | null;
  status: string;
};
export type PromoteProspectResponse = {
  created_new_patient: boolean;
  /** Patient the booking now belongs to */
  patient_id: string;
  prospect: BookingProspectSchema3;
};
export type PromoteProspectRequest = {
  /** Create a new patient from the prospect's contact info */
  create_new?: boolean;
  /** Existing patient to link the booking to */
  patient_id?: string | null;
};
